import { Footprints, LogIn, Percent, Users, XCircle } from 'lucide-react';
import { SummaryCard } from '@/pages/Dashboard';
import type { NavDetail } from '@/types/navigation-report';
import { fmtNav } from './format';

interface DetailCardsProps {
    detail: NavDetail;
    periodLabel: string;
}

/** 5 cards da P1 aberta — todos exclusivos dela. */
export function DetailCards({ detail, periodLabel }: DetailCardsProps) {
    return (
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-border bg-border md:grid-cols-5">
            <SummaryCard flush period={periodLabel} title="Sessões" value={fmtNav.num(detail.sessions)} icon={LogIn} iconColor="text-emerald-500" accent="border-t-emerald-500/50" subtitle="entraram por esta página" />
            <SummaryCard flush period={periodLabel} title="Visitantes" value={fmtNav.num(detail.visitors)} icon={Users} iconColor="text-violet-500" accent="border-t-violet-500/50" subtitle="únicos" />
            <SummaryCard flush period={periodLabel} title="Avançaram" value={fmtNav.num(detail.advanced)} icon={Footprints} iconColor="text-blue-500" accent="border-t-blue-500/50" subtitle="viram uma 2ª página" />
            <SummaryCard flush period={periodLabel} title="Não avançaram" value={fmtNav.num(detail.not_advanced)} icon={XCircle} iconColor="text-slate-400" accent="border-t-slate-400/50" subtitle="saíram na 1ª página" />
            <SummaryCard flush period={periodLabel} title="Taxa de avanço" value={fmtNav.pct1(detail.advance_rate_pct)} icon={Percent} iconColor="text-amber-500" accent="border-t-amber-500/50" subtitle="avançaram / sessões" />
        </div>
    );
}
